import angular from 'angular';
import AnnouncementItemComponent from './announcement-item-component';

export default angular.module('announcement-item', []).component('announcementItem', new AnnouncementItemComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-item/announcement-item-module.js